import { render } from "./CLink.vue?vue&type=template&id=36d179cc"
import script from "./CLink.vue?vue&type=script&lang=js"
export * from "./CLink.vue?vue&type=script&lang=js"

import exportComponent from "/home/ydf/remit/shared/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__